import { DEFAULT_DASHBOARD_SETTINGS } from '@bms/common';
import type { FlavourFeatures } from './types';

export const commercialFeatures: FlavourFeatures = {
  hasAccessControl: true,
  hasDashboard: true,
  hasScenes: true,
  hasDND: false,
  hasMUR: false,
  hasOccupancy: true,
  hasHousekeeping: false,
  hasEnergyMeters: true,
  roomCardVariant: 'compact',
  dashboardLayout: 'list',
  dashboardHierarchy: { ...DEFAULT_DASHBOARD_SETTINGS, hierarchyLayout: 'tree' },
};
